import CommonImageUtil from '@blade/common/utils/image-util';
export default class ImageUtil extends CommonImageUtil {
    /**
     * url转换为base64
     * @param url 文件地址
     */
    static urlToBase64(url) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('get', url, true);
            xhr.responseType = 'blob';
            xhr.onload = function () {
                if (this.status === 200) {
                    const fr = new FileReader();
                    fr.onloadend = function (e) {
                        resolve(e.target?.result);
                    };
                    fr.readAsDataURL(this.response);
                }
                else {
                    reject(xhr.status);
                }
            };
            xhr.send();
        });
    }
    static srcToImage(src) {
        return new Promise((resolve, reject) => {
            if (!src)
                throw Error('src is empty');
            let url = '';
            if (typeof src === 'string')
                url = src;
            else
                url = URL.createObjectURL(src);
            const image = new Image();
            image.setAttribute('crossOrigin', 'anonymous');
            image.onload = () => {
                URL.revokeObjectURL(url);
                resolve(image);
            };
            image.onerror = () => {
                URL.revokeObjectURL(url);
            };
            image.src = url;
        });
    }
    /**
     * 裁切图片
     * @param src
     * @param coordinate
     */
    static cuttingImage(image, coordinate) {
        const canvas = document.createElement('canvas');
        // 坐标点 绝对
        const x = Math.round(image.naturalWidth * coordinate.x);
        const y = Math.round(image.naturalHeight * coordinate.y);
        const w = Math.round(image.naturalWidth * coordinate.w);
        const h = Math.round(image.naturalHeight * coordinate.h);
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        if (ctx == null)
            throw Error('canvas rendering error');
        ctx.drawImage(image, x, y, image.naturalWidth, image.naturalHeight, 0, 0, image.naturalWidth, image.naturalHeight);
        const url = ctx.canvas.toDataURL();
        return { url, width: w, height: h };
    }
    /**
     * 匹配图片大图的坐标点小图
     * @param src
     * @param coordinates
     */
    static async mattingImage(src, coordinates) {
        const image = await this.srcToImage(src);
        if (!coordinates)
            return [{ url: src, width: image.naturalWidth, height: image.naturalHeight }];
        return coordinates.map(c => this.cuttingImage(image, c));
    }
    /**
     * 图片缩放
     * @param containImageParams 图片缩放的参数对象
     */
    static containImage(containImageParams) {
        const { targetHeight, targetWidth } = containImageParams;
        let { currentHeight, currentWidth } = containImageParams;
        let s = 0;
        if (currentWidth > currentHeight) {
            s = currentWidth / currentHeight;
            currentWidth = targetWidth;
            currentHeight = currentWidth / s;
        }
        else {
            s = currentWidth / currentHeight;
            currentHeight = targetHeight;
            currentWidth = currentHeight * s;
        }
        if (targetHeight < currentHeight) {
            s = currentWidth / currentHeight;
            currentHeight = targetHeight;
            currentWidth = currentHeight * s;
        }
        if (targetWidth < currentWidth) {
            s = currentWidth / currentHeight;
            currentWidth = targetWidth;
            currentHeight = currentWidth / s;
        }
        return { width: currentWidth, height: currentHeight };
    }
}
